module.exports = __webpack_public_path__ + "img/audio-on.1363a0ac.svg";